import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {AbstractComponent} from '@components';
import {TranslocoService} from '@ngneat/transloco';
import {Lookups} from 'src/app/model/lookups';
import {ApplicationFormSettings} from 'src/app/model/race-registration-form-settings';
import {RegistrationDisplayFlags} from 'src/app/model/registration-display-flags';
import {VisibilityTypes} from 'src/app/model/visibilty-types';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-race-details-registration-settings-default-field-form',
  templateUrl: './race-details-registration-settings-default-field-form.component.html',
  styleUrls: ['./race-details-registration-settings-default-field-form.component.scss']
})
export class RaceDetailsRegistrationSettingsDefaultFieldFormComponent extends AbstractComponent implements OnInit, OnChanges {

  @Input() applicationFromSettings: ApplicationFormSettings | undefined;
  @Input() disabled: boolean = false;
  @Input() registrationDisplayFlags: Lookups[] = [];
  @Input() visibilityTypes: Lookups[] = [];
  @Input() title: string = "";

  @Input() visibilityKey: keyof ApplicationFormSettings | undefined;
  @Input() registrationDisplayFlagKey: keyof ApplicationFormSettings | undefined;
  @Input() requiredKey: keyof ApplicationFormSettings | undefined;

  @Input() publicVisibilitySelectionDisabled: boolean = false;
  @Input() visibilitySelectionDisabled: boolean = false;
  @Input() registrationDisplayFlagSelectionDisabled: boolean = false;
  @Input() requiredSelectionDisabled: boolean = false;

  @Input() optionsKey: keyof ApplicationFormSettings | undefined;
  @Input() dropdownLabel: string = "";
  @Input() optionsList: Lookups[] = [];
  @Input() optionLabelPrefixKey: string | undefined;
  @Input() fieldLabel: string = "";

  @Input() textFieldKey: keyof ApplicationFormSettings | undefined;
  @Input() textFieldPlaceholder: string = "";
  @Input() textFieldPlaceholderPrefix: string = "";

  @Input() textFieldLabel: string = "";
  @Input() textFieldKeyEng: keyof ApplicationFormSettings | undefined;
  @Input() textFieldKeyIta: keyof ApplicationFormSettings | undefined;
  @Input() textFieldKeySlo: keyof ApplicationFormSettings | undefined;
  @Input() textFieldKeySr: keyof ApplicationFormSettings | undefined;
  @Input() textFieldKeyBs: keyof ApplicationFormSettings | undefined;

  @Output() statusChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() emitRegistrationDisplayFlagValueChanges: boolean = false;
  @Output() registrationDisplayFlagValueChange: EventEmitter<RegistrationDisplayFlags> = new EventEmitter<RegistrationDisplayFlags>();

  @Input() tooltip: string | undefined;

  VisibilityTypes = VisibilityTypes;
  RegistrationDisplayFlags = RegistrationDisplayFlags;

  multiLangForm = new FormGroup({
    textCro: new FormControl(),
    textEng: new FormControl(),
    textIta: new FormControl(),
    textSlo: new FormControl(),
    textSr: new FormControl(),
    textBs: new FormControl(),
  });

  invalid: boolean = false;
  panelStatus: 'error' | 'required' | 'optional' = 'optional';
  options: Map<number, string> = new Map()
  fieldUsed: boolean = false;
  modelHolder: DefaultField | undefined;


  constructor(public translocoService: TranslocoService, private modalService: NgbModal) {
    super()
  }

  ngOnInit() {
    this.initForm();
    if (this.textFieldKey || this.textFieldKeySlo || this.textFieldKeyIta || this.textFieldKeyEng || this.textFieldKeySr || this.textFieldKeyBs) {
      this.subscribeToMultilangFieldChange();
    }
    this.options = this.getOptions();
    this.validate();
    this.setModel();
    if (this.publicVisibilitySelectionDisabled) {
      this.visibilityTypes = this.visibilityTypes.filter(item=>item.id == VisibilityTypes.NOT_VISIBLE || item.id == VisibilityTypes.VISIBLE_TO_ADMINISTRATION);
    }
  }

  private initForm(): void {
    if ((this.getField(this.registrationDisplayFlagKey) ?? RegistrationDisplayFlags.NOT_USED) === RegistrationDisplayFlags.NOT_USED) {
      if (this.textFieldKey || this.textFieldKeyEng || this.textFieldKeyIta || this.textFieldKeySlo || this.textFieldKeySr|| this.textFieldKeyBs) {
        this.multiLangForm.disable();
      }
    } else {
      if (this.textFieldKey || this.textFieldKeySlo || this.textFieldKeyIta || this.textFieldKeyEng || this.textFieldKeySr || this.textFieldKeyBs) {
        this.multiLangForm.enable()
        if (this.textFieldKey) {
          this.multiLangForm.controls.textCro.setValue(this.getField(this.textFieldKey));
        }
        if (this.textFieldKeyEng) {
          this.multiLangForm.controls.textEng.setValue(this.getField(this.textFieldKeyEng));

        }
        if (this.textFieldKeyIta) {
          this.multiLangForm.controls.textIta.setValue(this.getField(this.textFieldKeyIta));

        }
        if (this.textFieldKeySlo) {
          this.multiLangForm.controls.textSlo.setValue(this.getField(this.textFieldKeySlo));
        }
        if (this.textFieldKeySr) {
          this.multiLangForm.controls.textSr.setValue(this.getField(this.textFieldKeySr));
        }
        if (this.textFieldKeyBs) {
          this.multiLangForm.controls.textBs.setValue(this.getField(this.textFieldKeyBs));
        }
      }

    }
  }


  private subscribeToMultilangFieldChange(): void {
    if (this.textFieldKey) {
      this.subscriptions.push(this.multiLangForm.controls.textCro.valueChanges.subscribe(value => {
        this.setField(this.textFieldKey!, value);
      }))
    }
    if (this.textFieldKeyEng) {
      this.subscriptions.push(this.multiLangForm.controls.textEng.valueChanges.subscribe(value => {
        this.setField(this.textFieldKeyEng!, value);
      }))
    }
    if (this.textFieldKeyIta) {
      this.subscriptions.push(this.multiLangForm.controls.textIta.valueChanges.subscribe(value => {
        this.setField(this.textFieldKeyIta!, value);
      }))
    }
    if (this.textFieldKeySlo) {
      this.subscriptions.push(this.multiLangForm.controls.textSlo.valueChanges.subscribe(value => {
        this.setField(this.textFieldKeySlo!, value);
      }))
    }
    if (this.textFieldKeySr) {
      this.subscriptions.push(this.multiLangForm.controls.textSr.valueChanges.subscribe(value => {
        this.setField(this.textFieldKeySr!, value);
      }))
    }
    if (this.textFieldKeyBs) {
      this.subscriptions.push(this.multiLangForm.controls.textBs.valueChanges.subscribe(value => {
        this.setField(this.textFieldKeyBs!, value);
      }))
    }
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['applicationFromSettings']?.currentValue !== changes['applicationFromSettings']?.previousValue) {
      this.validate();
      this.setModel();
    }
  }

  getPanelStatus(): 'error' | 'required' | 'optional' {
    if (this.invalid) return 'error';
    else {
      return this.getField(this.requiredKey) || this.isUsed()
      || this.isVisible() ? 'required' : 'optional';
    }
  }


  isVisible(): boolean {
    return (this.getField(this.visibilityKey) ?? VisibilityTypes.NOT_VISIBLE) !== VisibilityTypes.NOT_VISIBLE
  }

  isUsed(): boolean {
    return (this.getField(this.registrationDisplayFlagKey) ?? RegistrationDisplayFlags.NOT_USED) !== RegistrationDisplayFlags.NOT_USED || !this.registrationDisplayFlagKey
  }


  getOptions(): Map<number, string> {
    const optionsMap = new Map<number, string>();
    this.optionsList?.map((option: Lookups) => {
      if (option.id) {
        optionsMap.set(option.id, this.optionLabelPrefixKey ? this.translocoService.translate(this.optionLabelPrefixKey + option.id) : option.name ?? "")
      }
    });
    return optionsMap
  }


  hasOptionError() {
    return this.isUsed() && (this.optionsKey ?? false) && ((this.getField(this.optionsKey) ?? []).length < 1);
  }


  getField(fieldName: keyof ApplicationFormSettings | undefined): any {
    if (fieldName && this.applicationFromSettings) {
      return this.applicationFromSettings[fieldName];
    }
    return undefined;
  }


  setField(fieldName: keyof ApplicationFormSettings, value: any): void {
    // @ts-ignore
    this.applicationFromSettings![fieldName] = value;
    if (fieldName === this.registrationDisplayFlagKey) {
      if (this.isUsed()) {
        this.multiLangForm.enable();
        if (this.requiredKey !== undefined) {
          this.setField(this.requiredKey, true);
        }
      } else {
        this.multiLangForm.disable();
        if (this.requiredKey !== undefined) {
          this.setField(this.requiredKey, false);
        }
        if (this.visibilityKey !== undefined) {
          this.setField(this.visibilityKey, VisibilityTypes.NOT_VISIBLE);
        }
        if (this.optionsKey !== undefined) {
          this.setField(this.optionsKey, []);
        }
        if (this.textFieldKey !== undefined) {
          this.setField(this.textFieldKey, undefined);
        }
        if (this.textFieldKey || this.textFieldKeySlo || this.textFieldKeyIta || this.textFieldKeyEng || this.textFieldKeySr || this.textFieldKeyBs) {
          this.multiLangForm.controls.textCro.setValue(undefined);
          this.multiLangForm.controls.textEng.setValue(undefined);
          this.multiLangForm.controls.textIta.setValue(undefined);
          this.multiLangForm.controls.textSlo.setValue(undefined);
          this.multiLangForm.controls.textSr.setValue(undefined);
          this.multiLangForm.controls.textBs.setValue(undefined);
        }
      }
      if (this.emitRegistrationDisplayFlagValueChanges) {
        this.registrationDisplayFlagValueChange.emit(value);
      }
    }
    this.validate();
    this.setModel();
  }


  openModal(content: TemplateRef<any>) {
    if (!this.disabled) {
      this.modalService.open(content, {centered: true});
    }
  }

  private setModel(): void {
    this.modelHolder = new DefaultField(
      this.getField(this.registrationDisplayFlagKey),
      this.getField(this.requiredKey),
      this.getField(this.visibilityKey),
      this.getField(this.optionsKey),
    )
  }

  private validate() {
    this.invalid = this.hasOptionError();
    this.panelStatus = this.getPanelStatus();
    this.fieldUsed = this.isUsed();
    this.statusChanged.emit(this.invalid);
  }
}


class DefaultField {
  constructor(public registrationDisplayFlag?: number | undefined,
              public required?: boolean | undefined,
              public visibility?: number | undefined,
              public options?: number[] | undefined) {
  }
}

